import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  companyDetails: null,
  companyDetailsRequestId: null,
  companyDetailsLoading: false,
  companyDetailsError: null,
};

const companiesRegistration = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_REGISTRATION_REQUESTS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };

    case types.GET_COMPANY_DETAILS_REQUEST: {
      const { id, force } = action.payload;
      const alreadyHave =
        !force &&
        state.companyDetails &&
        String(state.companyDetailsRequestId) === String(id);
      if (alreadyHave) {
        return state;
      }
      return {
        ...state,
        companyDetailsLoading: true,
        companyDetailsError: null,
        companyDetails: null,
      };
    }

    case types.GET_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        companyDetailsLoading: false,
        companyDetailsError: null,
        companyDetails: action.payload.data,
        companyDetailsRequestId: action.payload.id,
      };

    case types.GET_COMPANY_DETAILS_FAILURE:
      return {
        ...state,
        companyDetailsLoading: false,
        companyDetailsError: action.payload.error,
        companyDetails: null,
        companyDetailsRequestId: null,
      };

    case types.CLEAR_COMPANY_DETAILS:
      return {
        ...state,
        companyDetails: null,
        companyDetailsRequestId: null,
        companyDetailsLoading: false,
        companyDetailsError: null,
      };

    default:
      return state;
  }
};

export default companiesRegistration;
